const EmilyClient = require('./emily')
const TCPAClient = require('./tcpa')
const {
  dangerouslyLoadTrustedFormScript,
  getTrustedFormFieldValues,
} = require('./trustedForm')

module.exports = {
  EmilyClient,
  TCPAClient,
  dangerouslyLoadTrustedFormScript,
  getTrustedFormFieldValues,
}
